import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { marketApi } from './api';

const RECENT_KEY = 'quantumtrade.recentSymbols';

function readRecents() {
  if (typeof window === 'undefined') return [];
  try {
    return JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
  } catch {
    return [];
  }
}

export default function TopBar({ title, subtitle, breadcrumbs = [] }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [query, setQuery] = useState('');
  const [recentSymbols, setRecentSymbols] = useState(readRecents);

  useEffect(() => {
    setRecentSymbols(readRecents());
  }, [location.pathname]);

  const handleSearch = async (event) => {
    event.preventDefault();
    const nextQuery = query.trim();
    if (!nextQuery) return;
    try {
      const data = await marketApi.search(nextQuery);
      if (data[0]?.symbol) {
        navigate(`/stocks/${data[0].symbol}`);
      }
    } catch {}
  };

  const recentItems = useMemo(() => recentSymbols.slice(0, 4), [recentSymbols]);

  return (
    <div className="page-header-card">
      <div className="page-header-copy">
        {breadcrumbs.length > 0 && (
          <div className="breadcrumb-row">
            {breadcrumbs.map((entry, index) => (
              <React.Fragment key={`${entry.label}-${index}`}>
                {index > 0 && <span className="breadcrumb-separator">/</span>}
                <span className={index === breadcrumbs.length - 1 ? 'breadcrumb-current' : 'breadcrumb-link'}>{entry.label}</span>
              </React.Fragment>
            ))}
          </div>
        )}
        <h2>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
      </div>

      <div className="page-header-actions">
        <form className="search-form" onSubmit={handleSearch}>
          <input
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="Search ticker or page"
            className="search-input"
          />
          <button type="submit" className="secondary-button small">
            Go
          </button>
        </form>
        <div className="header-pill-group">
          {recentItems.map((symbol) => (
            <button key={symbol} type="button" className="chip-button" onClick={() => navigate(`/stocks/${symbol}`)}>
              {symbol}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
